import { useEffect, useRef, useState } from "react";
interface OnImagesLoadedProps {
  children: React.ReactNode;
  placeholder?: React.ReactNode;
  onLoaded: () => void;
}
const OnImagesLoaded: React.FC<OnImagesLoadedProps> = ({
  children,
  onLoaded,
  placeholder,
}) => {
  //useEffect should be triggered whenever the component children change
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!containerRef.current) return;
    // reset loaded state
    setLoaded(false);
    const mediaElements = containerRef.current.querySelectorAll("img");

    const handleMediaLoad = () => {
      const allLoaded = Array.from(mediaElements).every(
        (element: any) => element.complete || element.readyState >= 3
      );
      if (allLoaded) {
        //trigger some callback
        setLoaded(true);
        onLoaded();
      }
    };

    // Attach event listeners for each media element.
    mediaElements.forEach((element) => {
      element.addEventListener("load", handleMediaLoad);
      // element.addEventListener("loadeddata", handleMediaLoad); // For video/audio elements.
    });

    // Run the handler initially in case some media are already loaded.
    handleMediaLoad();

    // Clean up event listeners when the component unmounts.
    return () => {
      mediaElements.forEach((element) => {
        element.removeEventListener("load", handleMediaLoad);
        //element.removeEventListener("loadeddata", handleMediaLoad);
      });
    };
  }, [children, containerRef]);
  return (
    <div ref={containerRef} className="w-100 h-100">
      <div
        style={{ display: loaded ? "block" : "none" }}
        className="w-100 h-100"
      >
        {children}
      </div>
      {!loaded && placeholder ? placeholder : null}
    </div>
  );
};

export default OnImagesLoaded;
